
import PopUpForm from "@/components/main/forms/PopUpForm";

export default {
  name: "Modal",
  mixins: [],
  components: {PopUpForm},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
